import {
    type Authentication,
    AccessDeniedError,
    AuthenticationError,
    InsufficientAuthenticationError,
    type ServerAuthenticationEntryPoint,
    isAuthentication
} from './types.js';
import {httpBasicEntryPoint} from './http-basic-entry-point.js';
import {ServerWebExchange} from '../../../types/web/server';
import {HttpStatus} from "../../http/status.ts";

async function commenceAuthentication(exchange: ServerWebExchange, authentication: Authentication | undefined, entryPoint: ServerAuthenticationEntryPoint) {
    const cause = new InsufficientAuthenticationError(`Full authentication is required to access this resource.`);
    const e: AuthenticationError = new AuthenticationError("Access Denied", {cause});
    if (authentication) {
        e.authentication = authentication;
    }
    await entryPoint(exchange, e);
}
export function httpStatusAccessDeniedHandler(httpStatus: HttpStatus) {
    return async (exchange: ServerWebExchange, _error: AccessDeniedError) => {
        exchange.response.setStatusCode(httpStatus);
        exchange.response.headers.set("Content-Type", "text/plain; charset=utf-8");
        const buffer = Buffer.from("Access Denied", "utf-8");
        exchange.response.headers.set('Content-Length', buffer.length);
        await exchange.response.body(buffer);
    };
}

export const errorFilter = (opts: {
    authenticationEntryPoint?: ServerAuthenticationEntryPoint
}) => {
    const accessDeniedHandler = httpStatusAccessDeniedHandler(HttpStatus.FORBIDDEN);
    const authenticationEntryPoint = opts.authenticationEntryPoint ?? httpBasicEntryPoint();
    return async (exchange: ServerWebExchange, next: () => Promise<void>) => {
        try {
            await next();
        } catch (error) {
            if (error instanceof AccessDeniedError) {
                const principal = await exchange.principal();
                if (!isAuthentication(principal)) {
                    await commenceAuthentication(exchange, undefined, authenticationEntryPoint);
                }
                else {
                    if (!principal.authenticated) {
                        await accessDeniedHandler(exchange, error);
                    }
                    await commenceAuthentication(exchange, principal, authenticationEntryPoint);
                }
                return;
            }
            throw error;
        }
    };
}
